import { useMemo } from 'react';

export const useRandomInteger = (min: number, max: number): number =>
    useMemo(() => Math.floor(Math.random() * (max - min)) + min, [max, min]);
